import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';
import type PriceFilterStore from '@tajawal/web-flights-sdk/lib/stores/filter/price-filter.store';

export function useStateOfPriceFilter(filter: PriceFilterStore) {
  return useMapStoreStateToClientState(filter, (filter: PriceFilterStore) => ({
    state: filter.state,
    isDirty: filter.isDirty,
    reset: filter.reset,
    set: filter.set,
    uncommittedState: filter.uncommittedState,
    commit: filter.commit,
    formatPriceWithDecimals: filter.$env.currency.formatPriceWithDecimals,
  }));
}
